//function to Parse the response
import { AxiosHeaders } from "axios";
import parse from "html-react-parser"; // To render HTML responses

export const cleanHTML = (text) => {
  if (!text) return "No response available.";
  const cleanedText = text
    .replace(/<\/?html>|<\/?head.*?>|<\/?body.*?>/g, "")
    .trim();
  return parse(text.replace(/```html|```/g, "").trim());
};

export const getUserLocalData = () => {
  const token = JSON.parse(localStorage.getItem("access_token"));
  const code = localStorage.getItem("code");
  const verifier = localStorage.getItem("verifier");
  const patient_id = localStorage.getItem("patient_id");
  const patient_name = localStorage.getItem("patient_name");
  const session_id = localStorage.getItem("session_id");
  const user_name = localStorage.getItem("user_name");
  const preferred_username = localStorage.getItem("preferred_username");
  const validPatientId =
    patient_id && patient_id !== "undefined" ? patient_id : null;
  return {
    token,
    code,
    verifier,
    patient_id,
    session_id,
    patient_name,
    validPatientId,
    user_name,
    preferred_username,
  };
};

export const getCustomPrompts = {
  patientStatus:
    "provide a full diagnostic on patient and provide next steps with recommended actions",
  admissionStatus: "Is this patient okay for discharge?",
  documentation:
    "Provide the progress note and discharge summary of this patient",
};

export const getTimeAgo = (timestamp) => {
  const now = new Date();
  const diffInSeconds = Math.floor((now - new Date(timestamp)) / 1000);

  if (diffInSeconds < 60) return `${diffInSeconds} sec ago`;
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours} hr ago`;
  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays} days ago`;
};

export const removeExistingSessionData = () => {
  localStorage.removeItem("patient_id");
  localStorage.removeItem("session_id");
  localStorage.removeItem("patient_name");
};

export const saveRecentChatPatientData = (data) => {
  console.log('res',data)
  localStorage.setItem("patient_id", data?.patient_id);
  localStorage.setItem("patient_name", data?.patient_name);
  localStorage.setItem("session_id", data?.conversation_id);
};

export const getHeaders = () => {
  const token = getUserLocalData().token;
  const headers = new AxiosHeaders();
  headers.set("Authorization", `Bearer ${token}`);
  headers.set("Content-Type", "application/json");
  headers.set("Accept", "application/json");
  return headers;
};

export const getNameInitials = (name) => {
  return name
    .match(/(\b\S)?/g)
    .join("")
    .toUpperCase();
};

export const generateCodeChallenge = async (verifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
};

export function generateRandomState() {
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
    ""
  );
}
export const generateCodeVerifier = () => {
  const randomBytes = window.crypto.getRandomValues(new Uint8Array(32));
  return btoa(String.fromCharCode.apply(null, randomBytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
};
export const getFilteredData = (url) => {
  // const url = 'https://example.com/page?name=John&age=30&token=abc123';
  const regex = /[?&]([^=#&]+)=([^&#]*)/g;

  let match;
  const params = {};

  while ((match = regex.exec(url)) !== null) {
    const key = decodeURIComponent(match[1]);
    const value = decodeURIComponent(match[2]);
    params[key] = value;
  }
  return params;
};
